import { useQuery } from 'react-query';

import { getEmailNotificationStatus as queryFn } from 'api/endPoints/getEmailNotificationStatus';

export const useQueryGetEmailNotificationStatus = () => {
    return useQuery<boolean, QueryError>('useQueryGetEmailNotificationStatus', queryFn, {
        placeholderData: true,
    });
};
